import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const IntegrationsJumbotron = (): JSX.Element => (
  <LandingPageJumbotron
    contentWidth="tight"
    description="integrations_privacy_section_copy"
    title="integrations_privacy_section_title"
  />
);

export default IntegrationsJumbotron;
